module.exports = __webpack_public_path__ + "img/react-ecommerce3.f70ba2d3.png";